import { Coords } from 'google-map-react'
import React from 'react'

import * as styles from './styles.module.scss'

interface ClusterProps extends Coords {
	onClick?: () => void
}

const Cluster: React.FC<ClusterProps> = (props) => {
	return <div className={styles.cluster} {...props} />
}

export default Cluster
